export default {
    // 接口地址
    baseUrl: ""
}
